import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Client } from '../models/client';
import { environment } from 'src/environments/environment';
import { ClientCategory } from '../models/clientCategory';
import { UserService } from './user.service';
import { Representative } from '../models/representative';

@Injectable()
export class RepresentativeService {
  public url: string;
  public urlIMFEL: string;
  public urlCuiIMFEL: string;

  constructor(private _http: HttpClient,  private userService: UserService) {
    this.url = environment.apiUrl;
    this.urlIMFEL = environment.apiIMFEL;
  }

  // GET ALL REPRESENTATIVE
  getAll(): Promise<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http
      .get(this.url + 'erpbackendint-representative', { headers: headers })
      .toPromise();
  }

  // INSERT CLIENT
  insert(representative: Representative): Promise<any> {
    let params = JSON.stringify(representative);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(this.url + 'erpbackendint-representative', params, { headers: headers }).toPromise();
  }

  // UPDATE CLIENT
  update(representative: Representative): Promise<any> {
    let params = JSON.stringify(representative);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(this.url + 'erpbackendint-representative', params, { headers: headers }).toPromise();
  }  
}
